export default __webpack_public_path__ + "ff144337bd232388cb479b71e24a15c4.png";